import { darkSeries } from "@/mocks/manga";

export default function DarkSection() {
  return (
    <section id="dark" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-primary-400 mb-2">暗黑连载 · 追更中</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              暗黑系长期连载
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {darkSeries.map((m) => (
            <article
              key={m.id}
              className="group flex gap-4 rounded-lg p-4 bg-background-100 border border-background-300/40 hover:border-primary-500/50 transition-colors"
            >
              <div className="shrink-0 w-20 h-28 rounded-md overflow-hidden relative">
                <img
                  src={m.cover}
                  alt={`${m.title} 暗黑漫画连载封面`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-primary-600/10 opacity-0 group-hover:opacity-100 transition-opacity"></span>
              </div>
              <div className="flex flex-col min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-1 truncate">
                  {m.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2 mb-2">
                  {m.desc}
                </p>
                <div className="flex flex-wrap gap-1.5 mb-2">
                  {m.tags.map((tag) => (
                    <span key={tag} className="px-1.5 py-0.5 rounded bg-secondary-200/40 text-secondary-300 text-[10px]">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between text-[11px] text-foreground-500">
                  <span>{m.chapter}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {m.rating.toFixed(1)}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}